export const SET_INVOICES = 'SET_INVOICES'
export const ADD_INVOICE = 'ADD_INVOICE'
export const UPDATE_INVOICE = 'UPDATE_INVOICE'
export const DELETE_INVOICE = 'DELETE_INVOICE'
export const DELETE_MULTIPLE_INVOICES = 'DELETE_MULTIPLE_INVOICES'
export const SET_SELECTED_INVOICES = 'SET_SELECTED_INVOICES'
export const SET_SELECTED_SUPPLIER_COMPANY = 'SET_SELECTED_SUPPLIER_COMPANY'
export const SET_TOTAL_INVOICES = 'SET_TOTAL_INVOICES'
export const RESET_CUSTOMER = 'RESET_CUSTOMER'
export const RESET_ITEM = 'RESET_ITEM'
export const SET_CUSTOMER = 'SET_CUSTOMER'
export const SET_ITEM = 'SET_ITEM'
export const SET_TEMPLATE_ID = 'SET_TEMPLATE_ID'
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER'
export const RESET_SELECTED_CUSTOMER = 'RESET_SELECTED_CUSTOMER'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const RESET_SELECTED_INVOICES = 'RESET_SELECTED_INVOICES'
export const UPDATE_INVOICE_STATUS = 'UPDATE_INVOICE_STATUS'
export const INVOICE_HAS_DELIVERYNOTE = 'INVOICE_HAS_DELIVERYNOTE'
export const SET_DELIVERYNOTE_ITEM = 'SET_DELIVERYNOTE_ITEM'

export const SET_SELECT_ALL_STATE_ITEM = 'SET_SELECT_ALL_STATE_ITEM'
export const SET_SELECTED_INVOICE_ITEMS = 'SET_SELECTED_INVOICE_ITEMS'
export const RESET_SELECTED_INVOICE_ITEMS = 'RESET_SELECTED_INVOICE_ITEMS'
export const SET_INVOICE_ITEMS = 'SET_INVOICE_ITEMS'
export const DELETE_INVOICE_MULTIPLE_ITEMS = 'DELETE_INVOICE_MULTIPLE_ITEMS'
export const TEMP_MULTIPLE_DELETE_ITEMS = 'TEMP_MULTIPLE_DELETE_ITEMS'
export const TEMP_DELETE_ITEM = 'TEMP_DELETE_ITEM'
export const TEMP_ADD_ITEM = 'TEMP_ADD_ITEM'
export const ADD_INVOICE_ITEMS = 'ADD_INVOICE_ITEMS'
export const DELETE_INVOICE_ITEM = 'DELETE_INVOICE_ITEM'
